import { Component, computed, input, output } from '@angular/core';
import { map, merge, Observable, of, switchMap, tap } from 'rxjs';
import { IFiat, ISpotRate, IWalletBalance } from '@libs/interfaces';
import { CommonModule } from '@angular/common';
import { CryptoBalancePipe } from '@libs/pipes/wallet/crypto.balance.pipe';
import { IconComponent } from '@libs/stand-alone-components/commons/icon/icon.component';
import { WalletService } from '@libs/app.services/wallet/wallet.service';
import { StoreWalletService } from '@libs/app.services/store/store-wallet.service';
@Component({
  selector: 'app-wallet-balance-row',
  templateUrl: './wallet-balance-row.component.html',
  styleUrls: ['./wallet-balance-row.component.scss'],

  imports: [CommonModule, CryptoBalancePipe, IconComponent],
})
export class WalletBalanceRowComponent {
  selected = input<boolean>();
  walletBalance = input<IWalletBalance>();
  wallet = computed(() => this.walletBalance().wallet);
  onselect = output<boolean>();
  loading = input<boolean>();
  baseCurrency$ = this.storeWalletService
    .selectDisplayFiat()
    .pipe(switchMap((displayFiat: boolean) => (displayFiat ? this.storeWalletService.selectBaseCurrency() : of(null))));
  balanceFiat$ = this.storeWalletService.selectBaseCurrency().pipe(
    switchMap((f: IFiat) =>
      this.storeWalletService
        .selectSpots()
        .pipe(
          map((spots: ISpotRate[]) =>
            spots.find((s: ISpotRate) => s.spot === `${this.walletBalance().wallet.code}/${f.code}`),
          ),
        ),
    ),
    map((spot: ISpotRate) => (spot.rate * this.walletBalance().balance) / this.walletBalance().wallet.metric),
  );
  onSelect$: Observable<any>;

  constructor(
    private service: WalletService,
    private storeWalletService: StoreWalletService,
  ) {}

  setSelected() {
    this.onSelect$ = merge(
      of(true),
      this.service.setSelectedCurrency(this.wallet().code).pipe(
        map(() => false),
        tap(() => this.onselect.emit(true)),
      ),
    );
  }
}
